export const LOGIN_ADMIN = "admin/login";